import React from "react"
import img from "../images/pricing.jpg"
import Back from "../common/Back"
import "./contact.css"
import { useLanguage } from "../../context/LanguageContext"

const Contact = () => {
  const { content } = useLanguage()
  const { contact } = content

  return (
    <>
      <section className='contact mb'>
        <Back name={contact.backName} title={contact.backTitle} cover={img} />
        <div className='container'>
          <form className='shadow' onSubmit={(event) => event.preventDefault()}>
            <h4>{contact.formTitle}</h4> <br />
            <div>
              <input type='text' placeholder={contact.namePlaceholder} />
              <input type='text' placeholder={contact.emailPlaceholder} />
            </div>
            <input type='text' placeholder={contact.subjectPlaceholder} />
            <textarea cols='30' rows='10' placeholder={contact.messagePlaceholder}></textarea>
            <button type='submit'>{contact.submitButton}</button>
          </form>
        </div>
      </section>
    </>
  )
}

export default Contact
